<template>
  <b-table striped
           v-if="versions"
           thead-class="d-none"
           :items="assetVersionsMap"
           :fields="assetVersionsFields">
    <template v-slot:cell(action)="data">
      <asset-version-row :version="data.item"/>
    </template>
  </b-table>
</template>

<script>
import startCase from "lodash/startCase";
import AssetVersionRow from "./AssetVersionRow";
import normalize from "json-api-normalize";
import Attributes from "../../../models/Attributes";

export default {

  data() {
    return {
      versions: []
    }
  },

  props: ['assetId'],

  watch: {
    assetId: {
      immediate: true,
      handler(assetId, oldAssetId) {
        if (assetId !== oldAssetId) {
          this.loadVersions(assetId)
        }
      }
    }
  },

  methods: {
    newValueParse(key, value) {
      if (key === 'status') {
        return startCase(value)
      } else {
        return value
      }
    },

    objectChangesMap: function (assetVersion) {
      const objectChanges = assetVersion.object_changes;
      const userName = `${assetVersion.user.first_name} ${assetVersion.user.last_name} `;
      const date = assetVersion.created_at;

      const messages = Object.keys(objectChanges).filter(objectKey => {
        const from = objectChanges[objectKey][0];
        const to = objectChanges[objectKey][1];
        return !((!from || from === "") && (!to || to === ""))
      }).map(objectKey => {
        const to = objectChanges[objectKey][1];
        return {
          author: userName,
          field: objectKey,
          event: assetVersion.event,
          oldValue: objectChanges[objectKey][0],
          newValue: this.newValueParse(objectKey, to),
          date: date,
        }
      }).filter(el => ['status', 'notes', 'data', 'category_id', 'tag_id', 'release_form_id', 'name', 'keywords', 'exclusive', 'usage', 'caption', 'copyright', 'location', 'rank_featured', 'ai_approved'].includes(el.field));

      return messages.length > 0 ? messages : null
    },

    loadVersions(assetId) {
      this.$http.get(`/curators/assets/${assetId}/versions`, {}).then(fulfilled => {
        return;
        // this.versions = normalize(fulfilled.body).get(Attributes.assetVersionAttributes.concat(Attributes.prefixed('user', Attributes.userAttributes)));
      })
    }
  },

  computed: {
    assetVersionsFields: function () {
      return ['action']
    },

    assetVersionsMap: function () {
      let compactedVersions = []

      const allVersions = this.versions.map(v => {
        return this.objectChangesMap(v);
      }).filter(m => m).flat();

      // The following code groups consecutive keywords events, summarizing new/old values
      allVersions.forEach(obj => {
        let lastObj = compactedVersions.slice(-1)[0]

        if (lastObj && lastObj.field === obj.field && obj.field === "keywords" && lastObj.event === obj.event && lastObj.author === obj.author) {
          const oldValue = Array.from(new Set([...lastObj.oldValue, ...obj.oldValue])).filter(el => el)
          const newValue = Array.from(new Set([...lastObj.newValue, ...obj.newValue])).filter(el => el)
          lastObj.oldValue = oldValue
          lastObj.newValue = newValue
        } else {
          if (obj.field === 'tag_id' || obj.field === 'category_id') {
            // only creations get triggered here. deletions are done by setting *_ids methods which don't trigger papertrail
            if (obj.event === 'create') {
              if (lastObj && lastObj.field === obj.field && lastObj.event === obj.event && lastObj.author === obj.author) {
                const currentObjOldValue = [...[obj.oldValue]].filter(el => el)
                const currentObjNewValue = [...[obj.newValue]].filter(el => el) // make sure its an array, even if empty

                lastObj.oldValue = Array.from(new Set([...lastObj.oldValue, ...currentObjOldValue])).filter(el => el)
                lastObj.newValue = Array.from(new Set([...lastObj.newValue, ...currentObjNewValue])).filter(el => el)
              } else {
                obj.oldValue = []
                obj.newValue = [...[obj.newValue]].filter(el => el)
                compactedVersions.push(obj)
              }
            }

          } else {
            compactedVersions.push(obj)
          }
        }
      })

      return compactedVersions
    },
  },

  components: {AssetVersionRow}
}
</script>